import bookingDetail from "app/operator/staff/pages/BookingDetail/translate/ja";
import dashboard from "app/operator/staff/pages/Dashboard/translate/ja";

export default {
  dashboard,
  bookingDetail,
};
